export default "__VITE_ASSET__CrT5KIur__"